var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('page-layout',[_c('v-row',[_c('v-col'),_c('v-col',{staticClass:"shrink"},[_c('auth-user-form',{staticClass:"mb-5"}),_c('redeem-coupon')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }